export default Component => Component.displayName || Component.name || 'Component'



// WEBPACK FOOTER //
// ./src/getDisplayName.js